<template>
  <div class="customer-year-frame-dialog-container">
    <el-dialog v-if="type===MapTo.TO_Y" :title="`${form.is_update?'修改申请':'申请年框'}`" :visible.sync="show"
               width="850px" center :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
        <el-form-item v-if="aim===MapAim.AIM_CUSTOMER" label="客户名称" prop="customer_id">
          <el-input disabled v-model="form.custom_customer_name" style="width: 100%;"/>
        </el-form-item>
        <el-form-item v-else label="集团名称" prop="combine_id">
          <el-input disabled v-model="form.custom_combine_name" style="width: 100%;"/>
        </el-form-item>
        <el-form-item label="签约时间" prop="sign_begin">
          <el-date-picker
              v-model="form.custom_sign_date_array"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :picker-options="shortcutsDateOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年框政策" prop="policy_type">
          <div class="form-policy">
            <div class="policy">
              <div class="flex">
                <div class="type">
                  <el-radio v-model="form.policy_type" :label="MapPolicyType.TYPE_KOL">KOL年框</el-radio>
                </div>
                <div class="subtype">
                  <div>
                    <el-radio v-model="form.custom_subtype.KOL.subtype" :label="MapPolicySubtype.TYPE_MEAS_ADD"
                              :disabled="disableKOL">累量政策
                    </el-radio>
                    <el-select :key="MapPolicySubtype.TYPE_MEAS_ADD+key_select"
                               v-if="form.custom_subtype.KOL.subtype===MapPolicySubtype.TYPE_MEAS_ADD"
                               v-model="form.custom_subtype.KOL.subtype_seal" placeholder="请选择" class="input"
                    >
                      <el-option v-for="item in optionsADDKOCThe" :key="item.label" :label="item.label"
                                 :value="item.label"/>
                    </el-select>
                  </div>
                  <div>
                    <el-radio v-model="form.custom_subtype.KOL.subtype" :label="MapPolicySubtype.TYPE_MEAS_THE"
                              :disabled="disableKOL">保量政策
                    </el-radio>
                    <el-select :key="MapPolicySubtype.TYPE_MEAS_THE+key_select"
                               v-if="form.custom_subtype.KOL.subtype===MapPolicySubtype.TYPE_MEAS_THE"
                               v-model="form.custom_subtype.KOL.subtype_seal" placeholder="请选择" class="input"
                    >
                      <el-option v-for="item in optionsPolicyKOLThe" :key="item.label" :label="item.label"
                                 :value="item.label"/>
                    </el-select>
                  </div>
                  <div>
                    <el-radio v-model="form.custom_subtype.KOL.subtype" :label="MapPolicySubtype.TYPE_MEAS_PURCHASE"
                              :disabled="disableKOL">普通采买
                    </el-radio>
                    <el-select :key="MapPolicySubtype.TYPE_MEAS_PURCHASE+key_select"
                               v-if="form.custom_subtype.KOL.subtype===MapPolicySubtype.TYPE_MEAS_PURCHASE"
                               v-model="form.custom_subtype.KOL.subtype_seal" placeholder="请选择" class="input"
                    >
                      <el-option v-for="item in OPTIONS_PURCHASE" :key="item" :label="item" :value="item"/>
                    </el-select>
                  </div>
                  <div>
                    <el-radio v-model="form.custom_subtype.KOL.subtype" :label="MapPolicySubtype.TYPE_MEAS_OTHER"
                              :disabled="disableKOL">其他{{ `\u3000\u3000` }}
                    </el-radio>
                  </div>

                </div>
              </div>
              <div class="flex">
                <div class="type">
                  <el-radio v-model="form.policy_type" :label="MapPolicyType.TYPE_KOC">KOC年框</el-radio>
                </div>
                <div class="subtype">
                  <div>
                    <el-radio v-model="form.custom_subtype.KOC.subtype" :label="MapPolicySubtype.TYPE_MEAS_THE"
                              :disabled="disableKOC">保量政策
                    </el-radio>
                    <el-select v-model="form.custom_subtype.KOC.subtype_seal" placeholder="请选择" class="input"
                               :disabled="disableKOC||form.custom_subtype.KOC.subtype!==MapPolicySubtype.TYPE_MEAS_THE">
                      <el-option v-for="item in optionsPolicyKOCThe" :key="item.label" :label="item.label"
                                 :value="item.label"/>
                    </el-select>
                  </div>
                  <div>
                    <el-radio v-model="form.custom_subtype.KOC.subtype" :label="MapPolicySubtype.TYPE_MEAS_OTHER"
                              :disabled="disableKOC">其他{{ `\u3000\u3000` }}
                    </el-radio>
                  </div>
                </div>
              </div>
            </div>
            <div class="policy-detail">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入政策明细"
                        maxlength="191" show-word-limit class="input" v-model="form.policy_subtype_other"/>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="付款方式" prop="pay_method">
          <el-select v-model="form.pay_method" :style="`${form.pay_method==='刊后全款'?'width: 50%;':'width: 100%;'}`">
            <el-option v-for="item in optionsPayMethods" :key="item + 'optionsPayMethods'" :label="item" :value="item"/>
          </el-select>
          <el-select v-if="form.pay_method==='刊后全款'" v-model="form.pay_method_sub"
                     style="width: calc(50% - 10px);margin-left: 10px;"
                     placeholder="账期选项">
            <el-option v-for="item in optionsPayMethodsSub" :key="item + 'optionsPayMethodsSub'" :label="item"
                       :value="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="最高级别负责人" prop="charge_person">
          <el-input v-model="form.charge_person"/>
        </el-form-item>
        <el-form-item label="职位" prop="post">
          <el-input v-model="form.post"/>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleClose">取 消</el-button>
      <el-button type="primary" size="mini" @click="handleSureY">确 定</el-button>
    </span>
    </el-dialog>
    <el-dialog v-else :title="`${userAuth.can_year_frame_cancel?'':'申请'}取消年框`" :visible.sync="show" width="520px"
               center :before-close="handleClose">
      <div class="current-info">
        <div v-if="form.combine_id">
          <span>集团名称：</span>
          <span>{{ form.custom_combine_name }}</span>
        </div>
        <div v-if="form.custom_customer_name">
          <span>客户名称：</span>
          <span>{{ form.custom_customer_name }}</span>
        </div>
        <div>
          <span>签约时间：</span>
          <span>{{ form.custom_sign_date_array.join('~') }}</span>
        </div>
        <div v-if="form.policy_alias">
          <span>年框政策：</span>
          <span>{{ form.policy_alias || '-' }}</span>
        </div>
        <div v-if="form.pay_method">
          <span>付款方式：</span>
          <span>{{ Array.isArray(form.pay_method) ? form.pay_method.join('、') : '-' }}</span>
        </div>
        <div v-if="form.charge_person">
          <span>最高级别负责人：</span>
          <span>{{ form.charge_person || '-' }}</span>
        </div>
        <div v-if="form.post">
          <span>职位：</span>
          <span>{{ form.post || '-' }}</span>
        </div>
        <div v-if="form.phone">
          <span>联系电话：</span>
          <span>{{ form.phone || '-' }}</span>
        </div>
        <div>
          <el-input type="textarea" :rows="2" placeholder="请输入取消原因" v-model="form.creator_remark"
                    style="width: 300px;margin-top: 8px;" maxlength="100" show-word-limit/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-alert v-if="form.combine_id" center
                  :title="`${userAuth.can_year_frame_cancel?'取消后':'申请通过后'}，【${form.custom_combine_name}】下所有客户都将变成非年框客户`"
                  type="error" :closable="false" effect="dark" style="margin-bottom: 10px;"/>
        <el-button size="mini" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSureN">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {shortcutsDateOptions, telephoneRule} from '@/config/business';
import {levelConfig, yearFrameStoreForN, yearFrameStoreForY} from "@/api/customerYearFrame";
import {YEAR_FRAME_COMBINE, YEAR_FRAME_CUSTOMER} from "@/config/business/code";

const MapAim = {
  AIM_CUSTOMER: 'CUSTOMER',
  AIM_COMBINE: 'COMBINE',
};
const MapPolicyType = {
  TYPE_KOL: 'KOL',
  TYPE_KOC: 'KOC',
};
const MapPolicySubtype = {
  TYPE_MEAS_THE: 'THE',
  TYPE_MEAS_ADD: 'ADD',
  TYPE_MEAS_OTHER: 'OTHER',
  TYPE_MEAS_PURCHASE: 'PURCHASE',
};
const MapTo = {
  TO_Y: 'TO_Y',
  TO_N: 'TO_N',
};
const MapPayMethods = ["预付全款", '预付半款', '刊后全款'];
const MapPayMethodsSub = ["账期30天", '账期60天'];
const ModelFormSubtype = {
  subtype: MapPolicySubtype.TYPE_MEAS_ADD,
  subtype_seal: null,
};

const OPTIONS_PURCHASE = [
  '单平台单项目合作1个红人（含1个）以上',
  '单平台单项目合作3个红人（含3个）以上',
  '单项目合作金额超20万',
]
const ModelForm = {
  is_update: false,
  id: 0,
  record_id_cancel: 0,
  customer_id: null,
  sign_begin: null,
  sign_end: null,
  pay_method: null,
  pay_method_sub: null,
  charge_person: null,
  post: null,
  phone: null,
  policy_type: MapPolicyType.TYPE_KOL,
  policy_subtype: MapPolicySubtype.TYPE_MEAS_ADD,
  policy_subtype_other: null,// 政策备注
  policy_subtype_seal: null, // 保量政策档次
  creator_remark: null,
  policy_alias: null,
  combine_id: null,
  custom_customer_name: null,
  custom_combine_name: null,
  custom_sign_date_array: [],
  custom_subtype: {
    KOL: {...{}, ...ModelFormSubtype},
    KOC: {...{}, ...ModelFormSubtype},
  },
};
const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请填写联系电话'))
  } else if (!telephoneRule.test(value)) {
    callback(new Error('联系电话格式不正确'))
  } else {
    callback()
  }
};
const rules = {
  customer_id: [{required: true, message: '请选择客户', trigger: 'blur'}],
  combine_id: [{required: true, message: '请选择集团', trigger: 'blur'}],
  sign_begin: [{required: true, message: '请选择签约日期', trigger: 'change'}],
  sign_end: [{required: true, message: '请选择签约日期', trigger: 'change'}],
  policy_type: [{required: true, message: '请选择政策', trigger: 'blur'}],
  pay_method: [{required: true, message: '请选择付款方式', trigger: 'change'}],
  charge_person: [{required: true, message: '请输入最高级别负责人', trigger: 'blur'}],
  post: [{required: true, message: '请输入职位', trigger: 'blur'}],
  phone: [{required: true, trigger: 'blur', validator: validatePhone}],
};

export default {
  name: "YearFrameApply",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String],
      default: MapTo.TO_Y
    },
    customer: {
      type: [Object, Boolean],
      default: false
    },
    originForm: {
      type: [Object, Boolean],
      default: false
    }
  },
  data() {
    return {
      rules,
      MapTo,
      MapAim,
      MapPolicyType,
      MapPolicySubtype,
      OPTIONS_PURCHASE,
      shortcutsDateOptions,
      optionsPayMethods: MapPayMethods,
      optionsPayMethodsSub: MapPayMethodsSub,
      aim: MapAim.AIM_CUSTOMER,
      optionsADDKOCThe: [],
      optionsPolicyKOCThe: [],
      optionsPolicyKOLThe: [],
      tableLevelConfig: [],
      key_select: 'key',
      form: {...{}, ...ModelForm}
    }
  },
  computed: {
    disableKOL() {
      return this.form.policy_type === MapPolicyType.TYPE_KOC
    },
    disableKOC() {
      return this.form.policy_type === MapPolicyType.TYPE_KOL
    },
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.init();
      }
    },
    "form.custom_subtype.KOL.subtype"() {
      this.key_select = new Date().getTime()
      this.form.custom_subtype.KOL.subtype_seal = null
    },
    "form.custom_sign_date_array"(value) {
      this.form.sign_begin = null
      this.form.sign_end = null
      if (Array.isArray(value) && value.length) {
        this.form.sign_begin = value[0]
        this.form.sign_end = value[1]
      }
    },
    "form.policy_type"(v) {
      if (v === MapPolicyType.TYPE_KOL) {
        this.form.custom_subtype.KOC = {...{}, ...ModelFormSubtype}
      } else {
        this.form.custom_subtype.KOL = {...{}, ...ModelFormSubtype}
        this.form.custom_subtype.KOC.subtype = MapPolicySubtype.TYPE_MEAS_THE
      }
    },
    "form.pay_method"(v) {
      if (v !== '刊后全款') {
        this.form.pay_method_sub = null
      }
    }
  },
  mounted() {
    this.getLevelConfig()
  },
  methods: {
    init() {
      if (this.originForm) {
        this.form = {...{}, ...ModelForm}
        this.form = {...this.form, ...this.originForm}
      } else {
        const {type, is_update, customer_id, combine_id, record_id_cancel, policy_alias} = this.customer
        const params = {type, is_update, customer_id, combine_id, record_id_cancel, policy_alias}
        this.form = {...{}, ...ModelForm}
        this.form = {...this.form, ...params}
        this.form.custom_customer_name = this.customer.customer_name
        this.form.custom_combine_name = this.customer.combine_name
        if (this.customer.sign_end && this.customer.sign_begin) {
          this.form.custom_sign_date_array = [this.customer.sign_begin, this.customer.sign_end]
        }
      }
      // 初始化目标
      this.initAim()
      // 初始化目标
      this.initCustomSubtype()
    },
    initAim() {
      this.aim = this.form.combine_id ? MapAim.AIM_COMBINE : MapAim.AIM_CUSTOMER
    },
    initCustomSubtype() {
      if (this.form.policy_subtype)
        this.form.custom_subtype[this.form.policy_type].subtype = this.form.policy_subtype
      if (this.form.policy_subtype_seal)
        this.form.custom_subtype[this.form.policy_type].subtype_seal = this.form.policy_subtype_seal
    },
    /**
     * 提交保存
     */
    handleSureY() {
      const that = this;
      const params = {...{}, ...that.form}
      const policy_subtype_obj = that.form.custom_subtype[that.form.policy_type]
      if (policy_subtype_obj.subtype === MapPolicySubtype.TYPE_MEAS_THE) {
        if (!policy_subtype_obj.subtype_seal) {
          that.showToast({h: that, icon: "el-icon-error", text: '请选择保量政策条目', duration: 1000});
          return;
        }
      }
      if (policy_subtype_obj.subtype === MapPolicySubtype.TYPE_MEAS_OTHER) {
        policy_subtype_obj.subtype_seal = null
      }
      if (params.pay_method === '刊后全款' && !params.pay_method_sub) {
        that.showToast({h: that, icon: "el-icon-error", text: '请选择付款方式——账期选项', duration: 1000});
        return;
      }
      if (!params.policy_subtype_other) {
        that.showToast({h: that, icon: "el-icon-error", text: '请输入政策明细', duration: 1000});
        return;
      }

      params.policy_subtype = policy_subtype_obj.subtype
      params.policy_subtype_seal = policy_subtype_obj.subtype_seal
      params.record_id_cancel = 0
      params.id = this.form.is_update ? params.id : 0

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const response = await yearFrameStoreForY(params);
          await that.callbackApply(response);
        }
      });
    },
    /**
     * 确认取消年框
     * @returns {Promise<void>}
     */
    async handleSureN() {
      const that = this;
      if (!this.form.creator_remark) {
        that.showToast({h: that, icon: "el-icon-error", text: '请填写取消年框原因', duration: 2000});
        return;
      }
      const response = await yearFrameStoreForN({
        creator_remark: this.form.creator_remark,
        record_id_cancel: this.form.record_id_cancel,
        customer_id: this.form.customer_id,
        combine_id: this.form.combine_id,
        sign_begin: this.form.sign_begin,
        sign_end: this.form.sign_end,
      });
      await that.callbackApply(response);
    },
    /**
     * 申请响应处理
     * @param response
     */
    async callbackApply(response) {
      const that = this;
      if (!response.success) {
        const tipOption = {
          type: 'error', confirmButtonText: '前往处理', cancelButtonText: '知道了', showClose: false
        }
        if (response.code === YEAR_FRAME_CUSTOMER) {
          await that.$msgbox.confirm(`请为该集团【${response.message}】申请或审核年框`, '操作失败，该客户已归属集团', tipOption).then(() => {
            that.$router.push('/project/combine_customer')
          });
          return false;
        }
        if (response.code === YEAR_FRAME_COMBINE) {
          await this.$msgbox.confirm(`【${response.message}】是年框客户，请前往【${response.message}】【客户详情->年框信息->年框记录】模块，进行撤销`, '操作失败，该集团下已存在年框客户', tipOption);
          return false;
        }

        that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      that.showToast({h: that, icon: "el-icon-success", text: '操作成功！', duration: 2000});
      setTimeout(() => {
        that.handleClose();
      }, 2000)
      this.$emit('success');
    },
    /**
     * 关闭||取消
     */
    handleClose() {
      this.$emit('update:show', false);
    },
    /**
     * 获取保量政策
     * @returns {Promise<void>}
     */
    async getLevelConfig() {
      const responseKOL = await levelConfig({
        type_ko: MapPolicyType.TYPE_KOL,
        type_meas: MapPolicySubtype.TYPE_MEAS_THE
      });
      const responseKOC = await levelConfig({
        type_ko: MapPolicyType.TYPE_KOC,
        type_meas: MapPolicySubtype.TYPE_MEAS_THE
      });
      const responseKOCAdd = await levelConfig({
        type_ko: MapPolicyType.TYPE_KOL,
        type_meas: MapPolicySubtype.TYPE_MEAS_ADD
      });
      this.optionsPolicyKOLThe = responseKOL.model || [];
      this.optionsPolicyKOCThe = responseKOC.model || [];
      this.optionsADDKOCThe = responseKOCAdd.model || [];
      this.optionsPolicyKOLThe.map(_ => {
        _.label = _.show_end_money ? `${_.show_start_money}w-${_.show_end_money}w(含)` : `${_.show_start_money}w+`;
      })
      this.optionsPolicyKOCThe.map(_ => {
        _.label = _.show_end_money ? `${_.show_start_money}w-${_.show_end_money}w(含)` : `${_.show_start_money}w+`;
      })
      this.optionsADDKOCThe.map(_ => {
        _.label = _.show_end_money ? `${_.show_start_money}w-${_.show_end_money}w(含)` : `${_.show_start_money}w+`;
      })
    },

  }
}
</script>

<style lang="scss">
.customer-year-frame-dialog-container {
  //font-family: DINPro-Medium, DINPro Medium, sans-serif !important;

  .flex {
    display: flex;
  }

  .current-info {
    div {
      //text-align: center;
      width: 300px;
      margin: 0 auto;

      span:first-child {
        font-weight: bolder;
        //width: 115px;
        display: inline-block;
      }
    }

  }

  .form-policy {
    width: 100%;
    border: 1px solid #f2f2f2;
    height: 189px;

    .policy-detail {
      float: left;
      width: 160px;
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 10px;
    }

  }

  .policy {
    float: left;
    width: calc(100% - 180px);

    .type, .subtype {
      padding: 10px;
      border: 1px solid #f2f2f2;
    }

    .type {
      width: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: unset;
    }

    .subtype {
      width: calc(100% - 120px);

      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      div + div {
        margin-top: 4px;
      }
    }

    .input {
      width: 190px;
    }
  }
}
</style>
